import React, { useContext } from 'react';
import MainContext from 'MainContext';

export const ProWrapper = (props) => {
  const { adminType } = useContext(MainContext).login.shop_profile;
  return adminType !== 1 ? <>{props.children}</> : <></>;
};
